module.exports = {
    programmaticTitle:'程序化营销',
    dashboard: '大盘分析',
    report: '明细报告',
    setting: '设置',
    fixedDimension: '固定维度',
    creativesTemplate: '广告素材模板',
    bundleTemplate: 'Bundles模板',
    bundle: 'Bundle',
    selectAdv: '请选择广告主',
    uploadDate: '上传日期',
    records: '记录',
    activeTime: '当前时间',
    package: '包名',
    selectPackage: '请选择包',
    selectPid: '请选择包pid',
    day: '日期',
    affiliate: '渠道',
    creativeID: '广告素材 ID',
    creativeSize: '广告素材 尺寸',
    vsLastPeriod: '对比上期',
    top5Bundles: '前5Bundles',
    rankingByConversion: '按转化排名',
    selectDateRange: '请选择时间范围',
    uploadExcelFile: '请上传excel文件',
    addPid: '请添加PID',
    addPkg: '请添加PKG',
    reUpload: '重新上传',
    trends: '趋势',
    underConstruction: '建设中',
    affId: '渠道 ID',
    subAffId: '虚拟子渠道 ID',
    confirmDelete: '确认删除？',
    inputAffId: '请输入渠道ID',
    inputSubAffId: '请输入虚拟子渠道ID',
    affIdHave: '渠道ID已存在',
    affIdNumValidate: '渠道 ID 为数字',
    shadowAffIdNumValidate: '虚拟子渠道 ID 为数字',
    affIdNoMoreSix: '渠道 ID 不能超过6位',
}



// WEBPACK FOOTER //
// ./src/i18n/modules/programmatic/zh-cn.js